<template>
  <div>
    <div draggable="true" v-for="item in nodes" :key="item.id" style="background: #3f4b5f;margin-bottom: 2px;padding-top: 2px;"
         @dragstart="dragStart($event, item.id)">
      <div style="text-align: right;line-height: 40px;height: 40px;width: 100%;padding-right: 4px;background-size: contain;background-repeat:no-repeat;box-sizing: border-box"
           :style="{backgroundImage:'url('+require('@/assets/g6/'+item.id+'.png')+')'}">{{item.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NodesBar",
  data(){
    return {
      nodes:[
        {id:'rect',name:'矩形'},
        {id:'circle',name:'圆形'},
        {id:'diamond',name:'菱形'},
        {id:'ellipse',name:'椭圆'},
        {id:'star',name:'星形'},
        {id:'triangle',name:'三角形'},
        {id:'image',name:'图片'},
      ]
    }
  },
  methods:{
    dragStart(e, id) {
      e.dataTransfer.setData("nodeType", id);
      let copyDom = e.currentTarget.cloneNode(true);
      this.$emit('dragStart', copyDom);
    },
  }
}
</script>

<style scoped>

</style>
